import type { HomeSettings } from "building-types/settings/homeSettings";
import beazerSettings from "./settings/beazerSettings";
import brockSettings from "./settings/brockSettings";
import craftSettings from "./settings/craftSettings";
import defaultBuilderSettings from "./settings/defaultBuilderSettings";
import elliottSettings from "./settings/elliottSettings";
import epconSettings from "./settings/epconSettings";
import esperanzaSettings from "./settings/esperanzaSettings";
import essexExteriorSettings from "./settings/essexSettings";
import farmhouseSettings from "./settings/farmhouseSettings";
import redTreeSettings from "./settings/redTreeSettings";
import smithDouglasSettings from "./settings/smithDouglasSettings";

const settingsLibrary: { [id: string]: HomeSettings } = {
  ...defaultBuilderSettings,
  ...smithDouglasSettings,
  ...epconSettings,
  ...beazerSettings,
  ...craftSettings,
  ...redTreeSettings,
  ...elliottSettings,
  ...essexExteriorSettings,
  ...brockSettings,
  ...farmhouseSettings,
  ...esperanzaSettings,
};

export default settingsLibrary;
